import { Box, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'

function IPv4Input(props) {
    const { varaint, onInputChange, value } = props;
    const initOctet = {
        first: '',
        second: '',
        third: '',
        fourth: '',
        subnet: ''
    };
    const [octet, setOctet] = React.useState(initOctet);
    const [ipValue, setIPValue] = React.useState(value);

    const handleChange = (value, name) => {
        const newValue = { ...octet };
        let isValid = false;
        if (value === "") {
            isValid = true;
        } else if (/^[0-9]+$/.test(value)) {
            // ถ้าเป็นตัวเลขล้วน ยอมรับ แต่ต้องตรวจสอบเพิ่มเติม: ไม่ให้กรณีฐาน value เริ่ม "*" แล้วมา paste ตัวเลข
            if (value !== "*") {
                isValid = true;
            }
        } else if (value === "*") {
            // ถ้า paste '*' เพียงตัวเดียว และเดิม value ว่างเปล่า => ยอมรับ
            if (newValue[name] === "") {
                isValid = true;
            }
        }
        // กรณีอื่นๆ ไม่ยอมรับ (เช่น "1*","*1","**","12*3" เป็นต้น)
        return isValid;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const hasErrorSyntax = handleChange(value, name);
        if (hasErrorSyntax) {
            const newValue = { ...octet, [name]: value };
            setOctet(newValue);
            if (varaint === 'wild_card') {
                setIPValue(`${newValue.first}.${newValue.second}.${newValue.third}.${newValue.fourth}`);
                onInputChange(`${newValue.first}.${newValue.second}.${newValue.third}.${newValue.fourth}`, validateWildCardFormat(`${newValue.first}.${newValue.second}.${newValue.third}.${newValue.fourth}`))
            } else {
                setIPValue(`${newValue.first}.${newValue.second}.${newValue.third}.${newValue.fourth}/${newValue.subnet}`);
                onInputChange(`${newValue.first}.${newValue.second}.${newValue.third}.${newValue.fourth}/${newValue.subnet}`, validateSubnetFormat(`${newValue.first}.${newValue.second}.${newValue.third}.${newValue.fourth}/${newValue.subnet}`));
            }
        }
    };

    // const validateWildCardFormat = (value) => {
    //     const regex = /^(\d{1,3}|\*)\.(\d{1,3}|\*)\.(\d{1,3}|\*)\.(\d{1,3}|\*)$/;
    //     const segments = value.split('.');
    //     for (const segment of segments) {
    //         if (segment === "*") continue;

    //         const num = Number(segment);
    //         if (!/^\d+$/.test(segment)) return false;
    //         if (num < 0 || num > 255) return false;
    //     }
    //     return regex.test(value);
    // };

    const validateSubnetFormat = (value) => {
        const regex = /^(\d{1,3}\.){3}\d{1,3}\/([0-9]|[1-2][0-9]|3[0-2])$/;
        const segments = value.split('/')[0].split('.');
        for (const segment of segments) {
            if (segment === "*") continue;

            const num = Number(segment);
            if (!/^\d+$/.test(segment)) return false;
            if (num < 0 || num > 255) return false;
        }
        return regex.test(value);
    };

    const validateWildCardFormat = (ip) => { // รองรับการตรวจสอบ Class A,B,C
        // แยกส่วนของ IP Address
        const segments = ip.split('.');
        if (segments.length !== 4) return false;

        const [firstOctet, ...rest] = segments;

        // ปฏิเสธหาก octet แรกเป็น '*'
        if (firstOctet === '*') return false;

        // ตรวจสอบว่าแต่ละ octet เป็นตัวเลขระหว่าง 0-255 หรือ '*'
        for (const segment of segments) {
            if (segment === '*') continue;
            if (!/^\d+$/.test(segment)) return false;
            const num = Number(segment);
            if (num < 0 || num > 255) return false;
        }

        // ตรวจสอบว่า octet แรกอยู่ในช่วงของ Class A, B หรือ C
        const firstOctetNum = Number(firstOctet);
        if (
            (firstOctetNum >= 1 && firstOctetNum <= 126) || // Class A
            (firstOctetNum >= 128 && firstOctetNum <= 191) || // Class B
            (firstOctetNum >= 192 && firstOctetNum <= 223) // Class C
        ) {
            return true;
        }

        // หากไม่อยู่ในช่วงที่กำหนด ถือว่าไม่ถูกต้อง
        return false;
    };

    useEffect(() => {
        if (ipValue !== props.value) {
            setOctet(initOctet);
            setIPValue('')
        }
    }, [props.value])

    return (
        <div className='flex flex-row gap-1 border border-gray-300 rounded-[5px] p-1.5 max-w-[220px]'>
            <TextField
                name="first"
                variant="standard"
                InputProps={{ disableUnderline: true }}
                inputProps={{ style: { textAlign: 'center', paddingBottom: 0 }, maxLength: 3 }}
                value={octet.first}
                onChange={(e) => {
                    handleInputChange(e)
                }}
            />
            <Typography variant="subtitle2" className='flex items-center'>.</Typography>
            <TextField
                name="second"
                variant="standard"
                InputProps={{ disableUnderline: true }}
                inputProps={{ style: { textAlign: 'center', paddingBottom: 0 }, maxLength: 3 }}
                value={octet.second}
                onChange={(e) => {
                    handleInputChange(e)
                }}
            />
            <Typography variant="subtitle2" className='flex items-center'>.</Typography>
            <TextField
                name="third"
                variant="standard"
                InputProps={{ disableUnderline: true }}
                inputProps={{ style: { textAlign: 'center', paddingBottom: 0 }, maxLength: 3 }}
                value={octet.third}
                onChange={(e) => {
                    handleInputChange(e)
                }}
            />
            <Typography variant="subtitle2" className='flex items-center'>.</Typography>
            <TextField
                name="fourth"
                variant="standard"
                InputProps={{ disableUnderline: true }}
                inputProps={{ style: { textAlign: 'center', paddingBottom: 0 }, maxLength: 3 }}
                value={octet.fourth}
                onChange={(e) => {
                    handleInputChange(e)
                }}
            />
            {varaint !== 'wild_card' &&
                <>
                    <Typography variant="subtitle2" className='flex items-center'>/</Typography>
                    <TextField
                        name="subnet"
                        variant="standard"
                        InputProps={{ disableUnderline: true }}
                        inputProps={{
                            style: { textAlign: 'center', paddingBottom: 0 },
                            maxLength: 2,
                        }}
                        value={octet.subnet}
                        onChange={(e) => {
                            handleInputChange(e)
                        }}
                    />
                </>
            }
        </div>
    )
}

export default IPv4Input